/**
 * sameGameParlayStyles.js — StyleSheet for SameGameParlayScreen.
 * Extracted verbatim from screens/SameGameParlay.jsx (god-file decomposition).
 */

import { Platform, StyleSheet } from 'react-native';
import { isMobile } from '../utils/responsive';

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#000000',
    },
    background: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: '#000000',
    },
    splashContainer: {
        flex: 1,
        width: '100%',
        height: '100%',
        paddingHorizontal: isMobile ? 12 : 48,
        paddingBottom: isMobile ? 16 : 48,
    },
    scrollView: {
        flex: 1,
    },
    scrollContent: {
        flexGrow: 1,
        paddingBottom: 450, // Extra space for sportsbooks dropdown
    },
    mainContent: {
        width: '100%',
        maxWidth: 1200,
        alignSelf: 'center',
        borderRadius: isMobile ? 12 : 20,
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderTopColor: 'rgba(255,255,255,0.25)',
        borderLeftColor: 'rgba(255,255,255,0.18)',
        borderRightColor: 'rgba(255,255,255,0.12)',
        borderBottomColor: 'rgba(255,255,255,0.08)',
        overflow: 'visible',
    },
    mainContentBlur: {
        padding: isMobile ? 16 : 32,
        gap: isMobile ? 20 : 28,
        borderRadius: isMobile ? 12 : 20,
        backgroundColor: 'rgba(19, 19, 19, 0.85)',
    },
    titleSection: {
        gap: 12,
        zIndex: 5000,
        position: 'relative',
    },
    titleRow: {
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: isMobile ? 'stretch' : 'flex-start',
        gap: 16,
        zIndex: 5000,
        position: 'relative',
    },
    titleTextContainer: {
        flex: 1,
        gap: 8,
    },
    title: {
        color: 'rgba(255, 255, 255, 0.85)',
        fontSize: isMobile ? 28 : 36,
        fontFamily: 'ClimateCrisis',
        fontWeight: '400',
        textTransform: 'uppercase',
        lineHeight: isMobile ? 32 : 40,
    },
    subtitle: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: isMobile ? 14 : 15,
        fontFamily: 'Slate',
    },
    searchTypeContainer: {
        width: isMobile ? '100%' : 180,
        zIndex: 4500,
        position: 'relative',
    },
    cacheStatus: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingVertical: 8,
        paddingHorizontal: 12,
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderRadius: 8,
        alignSelf: 'flex-start',
    },
    cacheStatusText: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 13,
    },
    filtersSection: {
        gap: isMobile ? 16 : 24,
        position: 'relative',
    },
    filtersRow: {
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 16 : 32,
        position: 'relative',
    },
    filtersColumn: {
        flex: 1,
        gap: isMobile ? 14 : 18,
        minWidth: 0, // Prevent overflow
        position: 'relative',
    },
    inputGroup: {
        gap: 8,
    },
    inputLabel: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
        fontWeight: '600',
    },
    textInputWrap: {
        borderRadius: 8,
        paddingVertical: 14,
        paddingHorizontal: 16,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.3)',
        backgroundColor: '#1a1a1a',
    },
    textInputField: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '500',
        ...(Platform.OS === 'web' ? { outlineStyle: 'none' } : {}),
    },
    lineRow: {
        flexDirection: 'row',
        gap: 12,
        width: '100%',
    },
    lineValueContainer: {
        flex: 1,
        gap: 8,
    },
    directionContainer: {
        flex: 1,
        minWidth: 0,
    },
    sectionLabel: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '700',
        marginBottom: 10,
    },
    sportsbooksSection: {
        marginTop: 4,
    },
    sportsbooksGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
    },
    sportsbookChip: {
        paddingVertical: 8,
        paddingHorizontal: 14,
        borderRadius: 20,
        backgroundColor: '#252525',
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.25)',
    },
    sportsbookChipSelected: {
        backgroundColor: '#4c2889',
        borderColor: '#8b5cf6',
    },
    sportsbookChipMyBook: {
        borderColor: 'rgba(162,89,255,0.6)',
        backgroundColor: 'rgba(162,89,255,0.12)',
    },
    sportsbookChipText: {
        color: 'rgba(255,255,255,0.85)',
        fontSize: 13,
        fontWeight: '500',
    },
    sportsbookChipTextSelected: {
        color: '#e9d5ff',
        fontWeight: '600',
    },
    queriesSection: {
        padding: 16,
        backgroundColor: 'rgba(59, 130, 246, 0.05)',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: 'rgba(59, 130, 246, 0.2)',
    },
    queryCard: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        marginBottom: 8,
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(59, 130, 246, 0.3)',
    },
    queryCardContent: {
        flex: 1,
    },
    queryCardNumber: {
        fontSize: 11,
        fontWeight: '600',
        color: '#3b82f6',
        marginBottom: 4,
        textTransform: 'uppercase',
    },
    queryCardText: {
        fontSize: 14,
        fontWeight: '600',
        color: 'rgba(255,255,255,0.9)',
    },
    legsSection: {
        padding: 16,
        backgroundColor: 'rgba(139, 92, 246, 0.05)',
        borderRadius: 12,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.2)',
    },
    legCard: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        marginBottom: 8,
        backgroundColor: 'rgba(139, 92, 246, 0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    legCardContent: {
        flex: 1,
    },
    legCardNumber: {
        fontSize: 11,
        fontWeight: '600',
        color: '#8b5cf6',
        marginBottom: 4,
        textTransform: 'uppercase',
    },
    legCardDescription: {
        fontSize: 14,
        fontWeight: '600',
        color: 'rgba(255,255,255,0.9)',
    },
    legCardDetails: {
        fontSize: 12,
        color: 'rgba(255,255,255,0.6)',
        marginTop: 4,
    },
    removeButton: {
        width: 28,
        height: 28,
        borderRadius: 14,
        backgroundColor: 'rgba(255,100,100,0.2)',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 12,
    },
    removeButtonText: {
        fontSize: 20,
        color: '#ff9f9f',
        fontWeight: '600',
        marginTop: -2,
    },
    queryPreview: {
        padding: 16,
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderRadius: 10,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.1)',
    },
    queryPreviewLabel: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        fontWeight: '700',
        marginBottom: 8,
        letterSpacing: 1,
    },
    queryPreviewText: {
        color: 'rgba(255,255,255,0.9)',
        fontSize: 15,
        fontWeight: '500',
        fontStyle: 'italic',
    },
    errorContainer: {
        padding: 12,
        backgroundColor: 'rgba(255,100,100,0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(255,100,100,0.3)',
    },
    errorText: {
        color: '#ff9f9f',
        fontSize: 14,
        fontWeight: '500',
    },
    actionButtons: {
        flexDirection: isMobile ? 'column' : 'row',
        gap: 12,
    },
    actionButton: {
        flex: isMobile ? undefined : 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        paddingVertical: 14,
        paddingHorizontal: 20,
        borderRadius: 10,
        borderWidth: 1.5,
    },
    addButton: {
        backgroundColor: 'rgba(139, 92, 246, 0.2)',
        borderColor: '#8b5cf6',
    },
    clearButton: {
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderColor: 'rgba(255,255,255,0.3)',
    },
    searchButton: {
        backgroundColor: 'rgba(34, 197, 94, 0.2)',
        borderColor: '#22c55e',
    },
    actionButtonText: {
        color: '#fff',
        fontSize: 15,
        fontWeight: '600',
    },
    actionButtonDisabled: {
        opacity: 0.4,
    },
    comingSoonOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    comingSoonBlur: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    comingSoonModal: {
        width: isMobile ? '90%' : 480,
        maxWidth: 480,
        borderRadius: isMobile ? 16 : 24,
        overflow: 'hidden',
        borderWidth: 1,
        borderColor: 'rgba(162, 89, 255, 0.3)',
    },
    comingSoonGradient: {
        padding: isMobile ? 24 : 40,
        alignItems: 'center',
    },
    comingSoonTitle: {
        fontSize: isMobile ? 24 : 32,
        fontFamily: 'ClimateCrisis',
        color: '#EBDEFF',
        marginBottom: isMobile ? 12 : 16,
        textTransform: 'uppercase',
    },
    comingSoonText: {
        fontSize: isMobile ? 14 : 16,
        fontFamily: 'Slate',
        color: 'rgba(255,255,255,0.8)',
        textAlign: 'center',
        lineHeight: isMobile ? 20 : 24,
        marginBottom: isMobile ? 24 : 32,
    },
    comingSoonButton: {
        minWidth: 200,
    },
    // Sportsbooks Multi-Select Dropdown Styles
    sportsbooksSelector: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#1a1a1a',
        borderRadius: 8,
        padding: 14,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.3)',
        marginTop: 8,
    },
    sportsbooksSelectorText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
        flex: 1,
    },
    sportsbooksArrow: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 12,
        marginLeft: 8,
    },
    sportsbooksDropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#0d0d0d',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.3)',
        marginTop: 4,
        zIndex: 99999,
        maxHeight: 400,
        overflow: 'hidden',
        ...(Platform.OS === 'web' && {
            boxShadow: '0 12px 48px rgba(0,0,0,0.9)',
        }),
    },
    sportsbooksDropdownHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        padding: 12,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.15)',
        backgroundColor: '#1a1a1a',
    },
    sportsbooksQuickAction: {
        paddingVertical: 6,
        paddingHorizontal: 10,
        backgroundColor: 'rgba(139,92,246,0.2)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(139,92,246,0.4)',
    },
    sportsbooksQuickActionText: {
        color: '#a78bfa',
        fontSize: 12,
        fontWeight: '600',
    },
    sportsbooksCloseBtn: {
        marginLeft: 'auto',
        paddingVertical: 6,
        paddingHorizontal: 10,
        backgroundColor: 'rgba(74,222,128,0.2)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(74,222,128,0.4)',
    },
    sportsbooksCloseBtnText: {
        color: '#4ade80',
        fontSize: 12,
        fontWeight: '600',
    },
    sportsbooksList: {
        padding: 12,
        maxHeight: 320,
        backgroundColor: '#0d0d0d',
    },
    sportsbooksTierLabel: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 11,
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginTop: 12,
        marginBottom: 8,
    },
    sportsbooksGridDropdown: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        backgroundColor: '#0d0d0d',
    },
    // Selected Sportsbooks Summary
    selectedSportsbooksSummary: {
        marginTop: 8,
        padding: 12,
        backgroundColor: '#1e1433',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: '#4c2889',
    },
    selectedSportsbooksHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    selectedSportsbooksLabel: {
        color: '#c4b5fd',
        fontSize: 13,
        fontWeight: '600',
    },
    clearSportsbooksBtn: {
        color: '#f87171',
        fontSize: 12,
        fontWeight: '600',
    },
    selectedSportsbooksChips: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
    },
    selectedSportsbookChip: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingVertical: 4,
        paddingLeft: 8,
        paddingRight: 6,
        backgroundColor: '#4c2889',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: '#7c3aed',
    },
    selectedSportsbookChipText: {
        color: '#e9d5ff',
        fontSize: 11,
        fontWeight: '600',
    },
    selectedSportsbookRemove: {
        color: '#c4b5fd',
        fontSize: 14,
        fontWeight: '600',
    },
});
